import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MemberType } from "src/types";
import { BranchType, mockBranch } from "../components/templates/design1/components";
import { capitalizeWords, mapRoleName } from "../components/utils";



type RawMember = {
    id: number;
    user_id: number;
    is_active: number; // Can be boolean if needed
    title: string;
    estate_title: string;
    picture: string;
    staff_role: string;
    name: string;
    email: string;
    phone: string;
};

export type RawBranch = {
    id: number;
    company_id: number;
    is_active: number;
    branch_name: string;
    branch_picture?: string;
    picture: string;
    state: string;
    local_government: string;
    city: string;
    branch_desc: string;
    branch_address: string;
    email: string | null;
    staffs_count: number;
    properties_count: number;
    landlords_count: number;
    tenants_count: number;
    staffs: RawMember[];
    properties: number;
    created_at: string;
    updated_at: string;
};

const transformBranchData = (branch: RawBranch): BranchType => {
    console.log({ branch })
    return {
        id: branch.id,
        branchName: branch.branch_name,
        picture: branch.branch_picture as string,
        state: branch.state,
        localGovernment: branch.local_government,
        city: branch.city,
        address: `${branch.branch_address}, ${branch.city} ${branch.local_government}, ${branch.state}`,
        description: branch.branch_desc,
        branchSummary: {
            title: "Branch Summary",
            values: {
                total_staff: branch.staffs_count,
                property_for_rent: branch.staffs_count,
                property_for_sale: 0,
                property_for_short_let: 0,
                total_unit_managing: branch.staffs_count,
                total_reviews: 0,
                completed_transaction: 0,
            }
        },
        staffs: branch.staffs.map((staff: RawMember): MemberType => ({
            name: `${staff.title} ${capitalizeWords(staff.name)}`,
            estateTitle: staff.estate_title,
            id: staff.id,
            title: staff.staff_role,
            role: mapRoleName(staff.staff_role),
            phone: staff.phone,
            email: staff.email,
            image: staff.picture,
        })),
    };
};

export const fetchBranch = async (branchId: number) => {
    const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
    console.log({ isDemo })
    if (isDemo) {
        return mockBranch
    }
    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_BASE_URL}api/v1/custom/company-branch-details/${branchId}`
    );
    console.log({ data })
    return transformBranchData(data.branch);
};

export const useFetchBranch = (branchId: number, initialData?: BranchType) => {

    return useQuery({
        queryKey: ["branch", branchId],
        queryFn: () => fetchBranch(branchId),
        enabled: !!branchId, // Ensures it only runs if branchId is valid
        staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
        refetchOnWindowFocus: false, // Prevent refetching on window focus
        placeholderData: keepPreviousData,
        initialData
    });
};
